import React, { lazy } from 'react';
import { Route } from 'react-router-dom';
import PageRoute from '../../components/Routes/PageRoute';

const Profile = lazy(
  () => import(/* webpackChunkName: "profile" */ './Profile')
);

export const profileRoute = (
  <Route
    path="profile"
    element={
      <PageRoute>
        <Profile />
      </PageRoute>
    }
  />
);
